import { Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useLocale } from "@/i18n/LocaleContext";
import { LANGS } from "@/i18n";
import { useAuth, api } from "@/App";

export default function LanguageSwitcher() {
  const { lang, setLang } = useLocale();
  const { user } = useAuth();

  const pick = (code) => {
    setLang(code);
    if (user) api.put("/users/profile", { language: code }).catch(() => {});
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="text-muted-foreground hover:text-white" data-testid="global-language-switcher">
          <Globe className="w-5 h-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-card border-white/10">
        {Object.entries(LANGS).map(([code, label]) => (
          <DropdownMenuItem
            key={code}
            onClick={() => pick(code)}
            className={lang === code ? "text-primary font-semibold" : ""}
            data-testid={`global-lang-option-${code}`}
          >
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
